// 组件
// 创建订单
import LeaseSetup from '../nodeComponents/CreateOrderInfo/components/LeaseSetupIndex.vue'
import SelectCustomer from '../nodeComponents/CreateOrderInfo/components/SelectCustomer.vue'
import CreateOrderInfo from '../nodeComponents/CreateOrderInfo/index.vue'
// 订单确认
import OrderConfirm from '../nodeComponents/OrderConfirm.vue'
// 订单支付
import OrderPayment from '../nodeComponents/OrderPayment.vue'
// 发车验车
import OperationOutIn from '../nodeComponents/OperationOutIn.vue'
// 完成
import AddComplete from '../nodeComponents/AddComplete.vue'

export default function config() {
  // 进度条数据
  /**
   * id: 对应 active 表明步骤的 index，从 0 开始
   * title: 步骤名
   * components: 当前步骤展示的组件
   */
  const stepsList = [
    {
      id: 0,
      title: '选择客户',
      components: CreateOrderInfo,
      childComponents: SelectCustomer,
    },
    {
      id: 1,
      title: '租赁设置',
      components: CreateOrderInfo,
      childComponents: LeaseSetup,
    },
    {
      id: 2,
      title: '订单确认',
      components: OrderConfirm,
    },
    {
      id: 3,
      title: '发车前收款（可跳过）',
      components: OrderPayment,
    },
    {
      id: 4,
      title: '发车验车',
      components: OperationOutIn,
    },
    {
      id: 5,
      title: '完成',
      components: AddComplete,
    },
  ]

  // 顶部预览配置
  const c_topPreviewList = [
    {
      el: 'text',
      itemConfig: {
        label: '所属门店',
        prop: 'storeName',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '客户类型',
        prop: 'rentCalculationRules',
        value: '个人客户',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '客户名称',
        prop: 'customerName',
      },
      elConfig: {
        jsxRender: () => {
          const verifyFn = this.orderInfoJumpRender
          if (verifyFn && typeof verifyFn === 'function' && this?.judgePermission('driver_customer_list_detail')) {
            return this.orderInfoJumpRender('customer')
          }
        },
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '租赁方案',
        prop: 'planName',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '品牌',
        prop: 'brandName',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '车系',
        prop: 'seriesName',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '车型',
        prop: 'modelName',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '绑定车辆',
        prop: 'plateNo',
      },
      elConfig: {
        jsxRender: () => {
          const verifyFn = this.orderInfoJumpRender
          if (verifyFn && typeof verifyFn === 'function' && this?.judgePermission('vehicle_list_detail')) {
            return this.orderInfoJumpRender('car')
          }
        },
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '租赁类型',
        prop: 'rentCategoryName',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '收款起止日期',
        prop: 'startStopDate',
      },
    },
  ]

  return {
    stepsList,
    c_topPreviewList,
  }
}
